// evaluableEmployeeMonitorReducer.js
import {
  GET_EVALUABLE_EMPLOYEES_MONITOR,
  IS_LOADING,
  ERROR,
} from './actionsType';

const initialState = {
  // Define your initial state here
  count: 0,
  evaluableEmployeesMonitor: [],
  isLoading: false,
  error: null,
};

const evaluableEmployeeMonitorReducer = (state = initialState, action) => {
  switch (action.type) {
    // Handle different action types here
    case GET_EVALUABLE_EMPLOYEES_MONITOR:
      return {
        ...state,
        evaluableEmployeesMonitor: action.payload.resultado,
        count: action.payload.count,
      };
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default evaluableEmployeeMonitorReducer;